import styled from 'styled-components';
import { TypographyStyles, colours, spacing } from '../../../stylings';

export const Wrapper = styled.div`
  background-color: ${colours.WHITE};
  height: fit-content;
  margin: ${spacing.XS} 0;
  min-height: 125px;
  min-width: 44px;
  width: fit-content;
`;

export const Label = styled.span`
  ${TypographyStyles.Headings.H5}
  display: block;
`;

export const ContentWrapper = styled.div`
  ${TypographyStyles.Body.Small.Regular}
`;
